import styles from "./ArtObjectsList.module.scss";

const ArtObjectsHeader = ({ sortKey, sortDirection, onSort }) => {
  const makeSortHandler = (key) => () => {
    if (onSort) {
      onSort(key);
    }
  };

  const renderSortLabel = (label, key, extraClassName) => {
    const isActive = sortKey === key;
    const direction = isActive ? sortDirection : "asc";
    return (
      <button
        type="button"
        className={`${styles.sortButton} ${
          isActive ? styles.sortActive : ""
        } ${extraClassName || ""}`}
        onClick={makeSortHandler(key)}
      >
        {label}
        <span className={styles.sortIndicator}>
          {isActive ? (direction === "asc" ? "▲" : "▼") : ""}
        </span>
      </button>
    );
  };

  return (
    <div className={`${styles.headerRow} ${styles.headerCard}`}>
      <div className={styles.left}>
        <span className={styles.infoContainer}>
          {renderSortLabel(
            "Warehouse",
            "warehouseName",
            styles.warehouseHeader
          )}
        </span>
        <span className={styles.infoContainer}>
          {renderSortLabel("Type", "type")}
        </span>
        <span className={styles.infoContainer}>
          {renderSortLabel("MTAB Serial", "serialNumber")}
        </span>
        <span className={styles.infoContainer}>
          {renderSortLabel("Inv. No", "inventoryNo")}
        </span>
      </div>
      <div className={styles.right}>
        <span className={styles.infoContainer}>
          {renderSortLabel("Title", "title")}
        </span>
        <span className={styles.infoContainer}>
          {renderSortLabel("Artist", "artist")}
        </span>
        <span className={styles.infoContainer}>
          {renderSortLabel("Type of art", "typeOfArt")}
        </span>
        <span className={styles.infoContainer}>
          {renderSortLabel("Date in", "orderInDate")}
        </span>
      </div>
    </div>
  );
};

export default ArtObjectsHeader;
